import { render, staticRenderFns } from "./MessageTypeRecipientsRemoved.vue?vue&type=template&id=29e1ef3a&"
import script from "./MessageTypeRecipientsRemoved.vue?vue&type=script&lang=js&"
export * from "./MessageTypeRecipientsRemoved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports